import Constants from '../constants/Constants';
import config from '../service/config';
import tabNames from '../constants/tabNames';

export const getCaptionEditorUrl = (mediaHash: string, tabName: string = tabNames.accessibility) => {
   const baseUrl = Constants.navigation.captionEditor.replace('{mediaHash}', mediaHash);
   const resourceLinkId = new URLSearchParams(window.location.search).get('resourceLinkId') || new URLSearchParams(window.location.search).get('resourcelinkid');

   const queryParams = new URLSearchParams();
   config.environmentData.IsLti && queryParams.append('isltisession', 'true');
   config.environmentData.IsLti && resourceLinkId && queryParams.append('resourceLinkId', resourceLinkId);
   tabName && queryParams.append('tab', tabName);

   return `${baseUrl}?${queryParams.toString()}`;
};
